module.exports = __webpack_public_path__ + "img/continue_answer_icon.a9a1235b.svg";